/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { ServiceTierRequestStatus } from '../../shared/entities/serviceTierRequest';
import ServiceTierRequest from '../../shared/entities/serviceTierRequest';
import ActionCreator from '../action-creator';


interface UpdateServiceTierRequestProps {
  requestId: string | null;
  status: ServiceTierRequestStatus;
}
interface PostServiceTierRequestProps {
  terminalDisplayName: string;
  terminalId: string;
  requestedServiceTier: string;
  requesterFullName: string;
  requesterEmail: string;
}

export const ActionCreators = {
  RequestServiceTierRequests: new ActionCreator<'RequestServiceTierRequests', any>('RequestServiceTierRequests'),
  ReceivedServiceTierRequestsSuccess: new ActionCreator<'ReceivedServiceTierRequestsSuccess', any>(
    'ReceivedServiceTierRequestsSuccess',
  ),
  ReceivedServiceTierRequestsError: new ActionCreator<'ReceivedServiceTierRequestsError', any>(
    'ReceivedServiceTierRequestsError',
  ),
  UpdateServiceTierRequest: new ActionCreator<'UpdateServiceTierRequest', UpdateServiceTierRequestProps>(
    'UpdateServiceTierRequest',
  ),
  UpdateServiceTierRequestSuccess: new ActionCreator<'UpdateServiceTierRequestSuccess', any>(
    'UpdateServiceTierRequestSuccess',
  ),
  UpdateServiceTierRequestError: new ActionCreator<'UpdateServiceTierRequestError', any>(
    'UpdateServiceTierRequestError',
  ),
  CancelServiceTierRequestsPoll: new ActionCreator<'CancelServiceTierRequestsPoll', any>(
    'CancelServiceTierRequestsPoll',
  ),
  ClearReceivedServiceTierRequestsError: new ActionCreator<'ClearReceivedServiceTierRequestsError', any>(
    'ClearReceivedServiceTierRequestsError',
  ),
  RequestCurrentServiceTierChangeRequest: new ActionCreator<'RequestCurrentServiceTierChangeRequest', string>('RequestCurrentServiceTierChangeRequest'),
  ReceivedCurrentServiceTierChangeRequestSuccess: new ActionCreator<'ReceivedCurrentServiceTierChangeRequestSuccess', any>(
    'ReceivedCurrentServiceTierChangeRequestSuccess',
  ),
  ReceivedCurrentServiceTierChangeRequestError: new ActionCreator<'ClearCurrentReceivedServiceTierChangeRequestError', any>(
    'ClearCurrentReceivedServiceTierChangeRequestError',
  ),
  ClearReceivedCurrentServiceTierChangeRequestError: new ActionCreator<'ClearReceivedCurrentServiceTierChangeRequestError', any>(
    'ClearReceivedCurrentServiceTierChangeRequestError',
  ),
  PostServiceTierRequest: new ActionCreator<'PostServiceTierRequest', PostServiceTierRequestProps>(
    'PostServiceTierRequest',
  ),
  ReceivedPostServiceTierRequestSuccess: new ActionCreator<'ReceivedPostServiceTierRequestSuccess', ServiceTierRequest>(
    'ReceivedPostServiceTierRequestSuccess',
  ),
  ReceivedPostServiceTierRequestError: new ActionCreator<'ReceivedPostServiceTierRequestError', any>(
    'ReceivedPostServiceTierRequestError',
  ),
  ClearReceivedPostServiceTierRequestStatus: new ActionCreator<'ClearReceivedPostServiceTierRequestStatus', any>(
    'ClearReceivedPostServiceTierRequestStatus',
  ),

  DeleteServiceTierChangeRequest: new ActionCreator<'DeleteServiceTierChangeRequest', any>(
    'DeleteServiceTierChangeRequest',
  ),
  ReceivedDeleteServiceTierChangeRequestSuccess: new ActionCreator<'ReceivedDeleteServiceTierChangeRequestSuccess', any>(
    'ReceivedDeleteServiceTierChangeRequestSuccess',
  ),
  ReceivedDeleteServiceTierChangeRequestError: new ActionCreator<'ReceivedDeleteServiceTierChangeRequestError', any>(
    'ReceivedDeleteServiceTierChangeRequestError',
  ),
  ClearReceivedDeleteServiceTierChangeRequestStatus: new ActionCreator<'ClearReceivedDeleteServiceTierChangeRequestStatus', any>(
    'ClearReceivedDeleteServiceTierChangeRequestStatus',
  ),

  RequestAvailableServiceTiers: new ActionCreator<'RequestAvailableServiceTiers', any>('RequestAvailableServiceTiers'),
  ReceivedAvailableServiceTiersSuccess: new ActionCreator<'ReceivedAvailableServiceTiersSuccess', any>(
    'ReceivedAvailableServiceTiersSuccess',
  ),
  ReceivedAvailableServiceTiersError: new ActionCreator<'ReceivedAvailableServiceTiersError', any>(
    'ReceivedAvailableServiceTiersError',
  ),
  ClearReceivedAvailableServiceTiersError: new ActionCreator<'ClearReceivedAvailableServiceTiersError', any>(
    'ClearReceivedAvailableServiceTiersError',
  ),
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function getServiceTierRequests() {
  return ActionCreators.RequestServiceTierRequests.create();
}
export function cancelServiceTierRequestsPoll() {
  return ActionCreators.CancelServiceTierRequestsPoll.create();
}
export function updateServiceTierRequest(requestId: string, status: ServiceTierRequestStatus) {
  return ActionCreators.UpdateServiceTierRequest.create({
    requestId: requestId,
    status: status,
  });
}
export function clearReceivedServiceTierRequestsError() {
  return ActionCreators.ClearReceivedServiceTierRequestsError.create();
}
export function getCurrentServiceTierChangeRequest(uuid: string) {
  return ActionCreators.RequestCurrentServiceTierChangeRequest.create(uuid);
}
export function clearReceivedCurrentServiceTierChangeRequestError() {
  return ActionCreators.ClearReceivedCurrentServiceTierChangeRequestError.create();
}
export function postServiceTierRequest(
  terminalDisplayName: string,
  terminalId: string,
  requestedServiceTier: string,
  requesterFullName: string,
  requesterEmail: string,
) {
  return ActionCreators.PostServiceTierRequest.create({
    terminalDisplayName,
    terminalId,
    requestedServiceTier,
    requesterFullName,
    requesterEmail,
  });
}
export function clearReceivedPostServiceTierRequestStatus() {
  return ActionCreators.ClearReceivedPostServiceTierRequestStatus.create();
}

export function getAvailableServiceTiers() {
  return ActionCreators.RequestAvailableServiceTiers.create();
}
export function clearReceivedAvailableServiceTiersError() {
  return ActionCreators.ClearReceivedAvailableServiceTiersError.create();
}



export function deleteServiceTierChangeRequest(id: String) {
  return ActionCreators.DeleteServiceTierChangeRequest.create(id);
}

export function clearDeleteServiceTierChangeRequest() {
  return ActionCreators.ClearReceivedDeleteServiceTierChangeRequestStatus.create();
}
